import { useContext } from "react";
import { AppContext } from "../App";
import AlertPopup from "./ui/AlertPopup";
import WarningIcon from "../icons/WarningIcon";

export default function CashmaticWarningPopup() {
	const { setSettingsPage, setSettingsVisible, setHideCashmaticWarning } = useContext(AppContext);

	// la visibilità (abilitazione, cassa non selezionata, "non mostrare più") la decide App.js
	return (
		<AlertPopup className="alert-compact">
			<div className="alert-compact-head">
				<WarningIcon className="alert-badge-icon" aria-hidden="true" />
				<strong className="alert-popup-title">Cassa automatica non selezionata</strong>
			</div>
			<p className="alert-compact-message">Seleziona una Cashmatic per incassare in contanti.</p>
			<div className="alert-compact-actions">
				<button
					className="button"
					onClick={() => {
						setSettingsPage("cashmatic");
						setSettingsVisible(true);
					}}
				>
					Seleziona
				</button>
				<button className="alert-text-link" onClick={() => setHideCashmaticWarning(true)}>
					Non mostrare più
				</button>
			</div>
		</AlertPopup>
	);
}
